import { emptyObject } from 'utils/emptyItems';

export const slugIdMapCreator = (list: any[] | null): { [key: string]: string } => {
  if (!list) return emptyObject;
  return list.reduce((acc: any, items: State.ProductType | State.Topic) => {
    acc[items.slug] = items.id;
    return acc;
  }, {});
};
